import { MODULES } from "Helpers/Constants";
import { setAllStore } from "Helpers/setAllStore";
import { convertDateTime } from "Helpers/date";
import moment from "moment";
import React, { useContext, useState } from "react";
import { CSVLink } from "react-csv";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getAccessByModuleName } from "Routes/Routes";
import { getSystemCommissionReportDetail } from "../../../../api/report";
import ViewIcon from "../../../../Assets/images/error-outline.svg";
import ReactTable from "../../../../Components/Table/Table";
import { AppContext } from "../../../../Context/AppContext";
import { formatUsPhone } from "../../../../Hooks/commanUtility";
import ExportIcon from "./../../../../Assets/images/Export.svg";
// Components
import Header from "./../../../../Components/Header/Header";
import styles from "./index.module.scss";
import GlobalDateFilters from "Components/GlobalDateFilters/GlobalDateFilters";

const SystemCommissionReportLookUp = () => {
  const { showToastMessage, modules } = useContext(AppContext);
  const navigate = useNavigate();
  const params = useParams();
  let accessExport = getAccessByModuleName(
    modules,
    MODULES.SYSTEM_COMMISSION_REPORT
  );

  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(1);
  const [productType, setProductType] = React.useState("");
  const [exportData, setExportData] = React.useState([]);
  const [exportHeader, setExportHeader] = React.useState([]);
  const [defaultFilter, setDefaultFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
    sortBy: [],
    filters: [],
    globalFilter: "",
  });
  const [type, setType] = useState("delivery_date");

  const [fromDate, setFromDate] = useState(
    moment().startOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [toDate, setToDate] = useState(
    moment().endOf("isoWeek").format("ddd MMM DD, YYYY")
  );
  const [selectedPeriod, setSelectedPeriod] = React.useState("weekly");

  const [firstTimePageLoad, setFirstTimePageLoad] = React.useState(false);

  const [checkAllStore, setCheckAllStore] = useState(true);

  const csr = params;
  const fetchData = async ({
    pageIndex,
    pageSize,
    sortBy,
    globalFilter,
    filters,
  }) => {
    /*
      # when all store checkbox is checked at that time we set page_wise_all_store_checkbox=0 in local storage & this logic write in setAllStore function
      
    */
    setAllStore(checkAllStore);

    setDefaultFilter({ pageSize, pageIndex, filters, globalFilter, sortBy });
    if (accessExport && accessExport.permissions.write_access)
      handleExportProductOrders(fetchData);

    setLoading(true);
    const postData = {
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
      csr_id: csr.id,
      isExport: false,
      currentPage: pageIndex,
      itemsPerPage: pageSize,
      date_type: type,
      filters,
      sortBy,
    };

    if (!firstTimePageLoad) {
      const response = await getSystemCommissionReportDetail(postData);
      if (response && response.status === 200) {
        setData(response.data.data.rows);
        setPageCount(Math.ceil(response.data.data.count.length / pageSize));
      } else if (response.status === 403) {
        showToastMessage(undefined, response.data.message, "error", false);
        navigate("/profile");
      } else {
        showToastMessage(undefined, response.data.message, "error", false);
      }
    } else {
      setFirstTimePageLoad(false);
    }
    setLoading(false);

    //when the all store checkbox is checked and we get all store data(after the API call) then we set the selected store id=dropdown selected store in local storage and this logic writes in setAllStore  function
    if (checkAllStore) {
      setAllStore(false);
    }
  };

  const handleExportProductOrders = async (event) => {
    if (!csr.id) return;

    let postData = {
      currentPage: event.pageIndex,
      itemsPerPage: event.pageSize,
      globalSearch: event.globalFilter,
      csr_id: csr.id,
      type: productType === "ALL" ? "" : productType,
      isExport: true,
      date_type: type,
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
    };

    const response = await getSystemCommissionReportDetail(postData);

    if (response && response.status === 200) {
      setExportHeader(response.data.data.header);
      setExportData(response.data.data.data);
    } else if (response.status === 403) {
      showToastMessage(undefined, response.data.message, "error", false);
      navigate("/profile");
    } else {
      showToastMessage(undefined, response.data.message, "error", false);
    }
  };

  const handleClearSearch = async (event) => {
    event.preventDefault();

    setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
    setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
    setSelectedPeriod("weekly");

    fetchData(defaultFilter);
    handleExportProductOrders(event);
  };

  //     setFromDate(moment().startOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("isoWeek").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("month").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("month").format("ddd MMM DD, YYYY"));
  //     setFromDate(moment().startOf("year").format("ddd MMM DD, YYYY"));
  //     setToDate(moment().endOf("year").format("ddd MMM DD, YYYY"));

  //     setToDate(moment(data).add(7, "days").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "months").utc().format("ddd MMM DD, YYYY"));
  //     setToDate(moment(data).add(1, "years").utc().format("ddd MMM DD, YYYY"));

  //     setFromDate(
  //       moment(data).subtract(7, "days").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "months").utc().format("ddd MMM DD, YYYY")
  //     setFromDate(
  //       moment(data).subtract(1, "years").utc().format("ddd MMM DD, YYYY")

  let viewOrderAccess = getAccessByModuleName(modules, MODULES.VIEW_ORDER);
  const columns = React.useMemo(
    () => [
      {
        Header: "Order N0",
        accessor: "order_number",
        isVisible: true,
        placeholder: "Search by Order N0",
      },
      {
        Header: "Customer Name",
        accessor: "customer_name",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return <div>{row.original.order_transaction.customer_name}</div>;
        },
      },
      {
        Header: "Recipient Name",
        accessor: "recipient_name",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return <div>{row.original.order_recipients[0].recipient_name}</div>;
        },
      },
      {
        Header: "Customer Phone",
        accessor: "customer_phone",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_transaction.customer_phone
              ? formatUsPhone(row.original.order_transaction.customer_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Recipient Phone",
        accessor: "recipient_phone",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return `${
            row.original.order_recipients[0].recipient_phone
              ? formatUsPhone(row.original.order_recipients[0].recipient_phone)
              : ""
          }`;
        },
      },
      {
        Header: "Delivery Date",
        accessor: "delivery_date",
        isVisible: true,
        Cell: ({ value, row, column }) => {
          return `${
            row.original.delivery_date && row.original.delivery_date !== null
              ? convertDateTime(
                  row.original.delivery_date,
                  "iso",
                  "ccc LLL dd, yyyy"
                )
              : ""
          }`;
        },
      },
      {
        Header: "Action",
        accessor: "id",
        isVisible: true,
        disableSortBy: true,
        Cell: ({ value, row, column }) => {
          return (
            <div>
              {viewOrderAccess && viewOrderAccess.permissions.read_access ? (
                <Link to={`/admin/orders/view/${row.original.id}`}>
                  <img
                    className={`cursor-pointer mr-2 view-icon`}
                    src={ViewIcon}
                    alt="Cancel Order"
                  />
                </Link>
              ) : (
                <span style={{ width: 34, height: 34, display: "block" }} />
              )}
            </div>
          );
        },
      },
    ],
    []
  );

  const selectedPeriodOptions = [
    { id: "weekly", title: "Weekly", label: "By Week" },
    { id: "monthly", title: "Monthly", label: "By Month" },
    { id: "yearly", title: "Yearly", label: "By Year" },
    { id: "custom", title: "Custom", label: "Custom" },
  ];
  return (
    <React.Fragment>
      <Header title="System Commission Report Lookup" />
      <div id="MainContent" className="main-content">
        <div style={{ float: "left", width: "100%" }}>
          <div className={"row d-flex align-items-end"}>
            <div className="col-11 m-0 p-0">
              <GlobalDateFilters
                isDateFilter
                isSearchIcon
                isClearSearchBtn
                isAllCheckStoreBnt
                isFilterByOption
                isFilterByPeriod
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                fetchData={()=>fetchData({
                  ...defaultFilter
                })}
                handleClearSearch={handleClearSearch}
                checkAllStore={(data)=>{setCheckAllStore(data)}}
                defaultSetCheckAllStore={checkAllStore}
                type={type} 
                setType={setType}
                selectedPeriod={selectedPeriod}
                setSelectedPeriod={setSelectedPeriod}
                periodOptions={selectedPeriodOptions}
                key={"system-commission-report-lookup"}
              />
            </div>
            <div className="col-1 mb-4">
              <div className="d-flex justify-content-end mb-3">
                {accessExport && accessExport.permissions.write_access && (
                  <span>
                    <CSVLink
                      data={exportData}
                      style={{ float: "right" }}
                      headers={exportHeader}
                      filename={"SystemCommissionReportLookup.csv"}
                      className={`link cursor-pointer ml-3 ${styles.searchIconWrapper}`}
                    >
                      <img
                        className={styles.searchIcon}
                        src={ExportIcon}
                        alt=""
                      />
                    </CSVLink>
                  </span>
                )}
              </div>
            </div>
          </div>

          <ReactTable
            columns={columns}
            data={data}
            fetchData={fetchData}
            loading={loading}
            pageCount={pageCount}
            noDataText={"There is no data to display"}
            defaultFilter={defaultFilter}
            displayGlobalSearch={false}
            displayColumnVisibility={true}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default SystemCommissionReportLookUp;
